var __TEMP__ = require('./_baseSortedIndex.js');var baseSortedIndex = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./eq.js');var eq = __REQUIRE_DEFAULT__(__TEMP__);

/**
 * This method is like `_.lastIndexOf` except that it performs a binary
 * search on a sorted `array`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 * @example
 *
 * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
 * // => 3
 */
function sortedLastIndexOf(array, value) {
  var length = array == null ? 0 : array.length;
  if (length) {
    var index = baseSortedIndex(array, value, true) - 1;
    if (eq(array[index], value)) {
      return index;
    }
  }
  return -1;
}

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = sortedLastIndexOf;
